import { useId } from "react";

import { cn } from "@/lib/utils";

export function ClearIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-2 text-berry", className)}
      fill="none"
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 .875l6.25 6.25m0-6.25L1 7.125"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function DownIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-1.5 w-2.5 text-white", className)}
      fill="none"
      viewBox="0 0 10 6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1l4 4 4-4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SelectedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill={`url(#${id}a)`} height="8" rx="4" width="8" x="6" y="6" />
      <rect
        height="18"
        rx="9"
        stroke={`url(#${id}b)`}
        strokeWidth="2"
        width="18"
        x="1"
        y="1"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="9.988"
          x2="9.988"
          y1="6"
          y2="14"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="9.971"
          x2="9.971"
          y1="0"
          y2="20"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}
